import React from 'react';
import { Box, Typography } from '@mui/material';
import ResponsiveDialogue from '../../ResponsiveDialogue/ResponsiveDialogue';
import RoundedButton from '../../RoundedButton/RoundedButton';
import { ADD_ANOTHER_USER, CONFIRM_USER_CREATION, CONTINUE_TO_DASHBOARD } from '../../../constants/messages';

interface ConfirmUserModalProps {
    open: boolean;
    onAddAnotherUser: () => void;
    onNavigate: () => void;
}

const ConfirmUserModal: React.FC<ConfirmUserModalProps> = ({ open, onAddAnotherUser, onNavigate }) => {
    return (
        <ResponsiveDialogue
            data-testid="audit-log-dialogue"
            open={open}
            onClose={onAddAnotherUser}
            title=""
        >
            <Box sx={{
                pt: 2
            }}>
                <Typography variant="body1" fontWeight="bold">{CONFIRM_USER_CREATION}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
                <Box sx={{ pr: 2 }}>
                    <RoundedButton
                        variantStyle="light"
                        variant="outlined"
                        data-testid="back-to-asset-detail-button"
                        onClick={() => onNavigate() }
                    >
                        {CONTINUE_TO_DASHBOARD}
                    </RoundedButton>
                </Box>
                <Box>
                    <RoundedButton
                        variantStyle="dark"
                        variant="contained"
                        data-testid="continue-to-asset-list-button"
                        onClick={() => onAddAnotherUser()}
                    >
                        {ADD_ANOTHER_USER}
                    </RoundedButton>
                </Box>
            </Box>
        </ResponsiveDialogue>
    );
};

export default ConfirmUserModal;
